import { defineMessages } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";

import { EntityTypeSupportedInOverviewPreview } from "@app/scene/reports/types/EntityTypeSupportedInOverviewPreview";

export const messages = defineMessages({
  downloadButton: {
    id: "reports.overview.listModal.downloadButton",
    defaultMessage: "Quick export",
    description: "Download entities button on the list modal for Overview Screen in Reports",
  },
  selectColumns: {
    id: "reports.overview.listModal.selectColumns",
    defaultMessage: "Select Columns",
    description: "Select Columns button on the list modal for Overview Screen in Reports",
  },
});

export const viewAllMessages = defineMessages<EntityTypeSupportedInOverviewPreview>({
  [EntityType.ACTIVITY]: {
    id: "reports.overview.grossMetric.viewAllActivities",
    defaultMessage: "View all Activities",
    description:
      "View all Activities link on the Activities list modal for Overview Screen in Reports",
  },
  [EntityType.COMPANY]: {
    id: "reports.overview.grossMetric.viewAllCompanies",
    defaultMessage: "View all Companies",
    description:
      "View all Companies link on the Companies list modal for Overview Screen in Reports",
  },
  [EntityType.DEAL]: {
    id: "reports.overview.grossMetric.viewAllDeals",
    defaultMessage: "View all Deals",
    description: "View all Deals link on the Deal list modal for Overview Screen in Reports",
  },
  [EntityType.PERSON]: {
    id: "reports.overview.grossMetric.viewAllPeople",
    defaultMessage: "View all People",
    description: "View all People link on the People list modal for Overview Screen in Reports",
  },
  [EntityType.ROUTE]: {
    id: "reports.overview.dealListModal.viewAllRoutes",
    defaultMessage: "View all Routes",
    description: "View all Routes link on the Route list modal for Overview Screen in Reports",
  },
});

export const modalTitleMessages = defineMessages<EntityTypeSupportedInOverviewPreview>({
  [EntityType.ACTIVITY]: {
    id: "reports.overview.grossMetric.activitiesCreated",
    defaultMessage: "Activities done",
    description: "Card title for Activities Created on Overview Screen.",
  },
  [EntityType.COMPANY]: {
    id: "reports.overview.grossMetric.companiesCreated",
    defaultMessage: "Companies Created",
    description: "Card title for Companies Created on Overview Screen.",
  },
  [EntityType.DEAL]: {
    id: "reports.overview.grossMetric.dealsCreated",
    defaultMessage: "Deals Created",
    description: "Card title for Deals Created on Overview Screen.",
  },
  [EntityType.PERSON]: {
    id: "reports.overview.grossMetric.contactsCreated",
    defaultMessage: "Contacts Created",
    description: "Card title for Contacts Created on Overview Screen.",
  },
  [EntityType.ROUTE]: {
    id: "reports.overview.grossMetric.routesCreated",
    defaultMessage: "Routes Created",
    description: "Card title for Routes Created on Overview Screen.",
  },
});
